import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
import { Alert, Layout, Spin } from 'antd';

import BidChanceDetailComponent from '../../components/bid-chances/BidChanceDetailComponent';
import BidProposalCreateModal from '../../components/bid-chances/BidProposalCreateModal';
import {
  BidChance,
  BidProposalParams,
  getBidChanceDetail2Async,
  updateBidChanceAsync,
} from '../../modules/bid-chances';
import { createBidProposal, downloadFile } from '../../api/constlink';

import {
  getBidChanceSharedFileAPIPath,
  getBidProposalFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
import { RootState } from '../../modules';
import { RouteComponentProps } from 'react-router-dom';
import BidInvitationInputModal from '../../components/bid-chances/BidInvitationInputModal';

interface BidInvitationContainerProps {}

function BidInvitationContainer({
  history,
}: RouteComponentProps<BidInvitationContainerProps>) {
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const { d1, d2, bmt } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidChances.bidChance,
  );
  const dispatch = useDispatch();
  const [coords, setCoords] = useState<any>();
  const [uploadProps, setUploadProps] = useState<any>();

  useEffect(() => {
    const copyToClipboard = async (val: string) => {
      await navigator.clipboard.writeText(val);
      alert(
        'URL주소가 복사되었습니다.\n\nSafari가 열리면 주소창을 길게 터치한 뒤, "붙여놓기 및 이동"를 누르면 정상적으로 이용하실 수 있습니다.',
      );
    };

    const redirectToExternalBrowser = () => {
      const targetUrl = window.location.href;
      copyToClipboard(targetUrl);

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        window.location.href = 'x-web-search://?';
      } else {
        window.location.href = `intent://${targetUrl.replace(
          /https?:\/\//i,
          '',
        )}#Intent;scheme=http;package=com.android.chrome;end`;
      }
    };

    const userAgent = navigator.userAgent.toLowerCase();
    if (/kakaotalk/i.test(userAgent)) {
      window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
        window.location.href,
      )}`;
    } else if (/line/i.test(userAgent)) {
      const targetUrl = window.location.href;
      window.location.href = targetUrl.includes('?')
        ? `${targetUrl}&openExternalBrowser=1`
        : `${targetUrl}?openExternalBrowser=1`;
    } else if (
      /inapp|naver|snapchat|wirtschaftswoche|thunderbird|instagram|everytimeapp|whatsApp|electron|wadiz|aliapp|zumapp|iphone.*whale|android.*whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|trill|SamsungBrowser\/[^1]/i.test(
        userAgent,
      )
    ) {
      redirectToExternalBrowser();
    }
  }, []);

  useEffect(() => {
    if (data === undefined || data === null) setVisible2(true);
    else setVisible2(false);
  }, [data]);

  useEffect(() => {
    const geocoder = new kakao.maps.services.Geocoder();
    if (data === null) return;
    if (data?.bidder?.bidPackage?.project?.location === undefined) return;
    geocoder.addressSearch(
      data.bidder.bidPackage.project.location,
      function (result: any[], status: any) {
        if (status === kakao.maps.services.Status.OK) {
          setCoords({ lat: result[0].y, lng: result[0].x });
        } else {
          setCoords({});
        }
      },
    );
  }, [data]);

  useEffect(() => {
    if (data === null) return;
    (async () => {
      setUploadProps(
        await initializeUploadProps(getBidProposalFileAPIPath(data.id + '')),
      );
    })();
  }, [data]);

  const changeBidStatus = (status: any) => {
    if (data === null) return;
    dispatch(
      updateBidChanceAsync.request({
        bidChance: {
          id: data.id,
          status,
        } as BidChance,
      }),
    );
  };

  const moveToCreateBidProposalPage = () => {
    setVisible1(true);
  };

  const closeBidProposalCreateModal = () => setVisible1(false);
  const submitBidProposal = async (formData: any) => {
    if (data === null) return;
    const bidProposalParams: BidProposalParams = {
      bidChanceId: data.id + '',
      bidProposal: {
        ...formData,
        bidProposalLineItems: [],
      },
    };
    if (bidProposalParams.bidProposal?.file) {
      for (const _file of bidProposalParams.bidProposal.file) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    try {
      await createBidProposal(bidProposalParams);
      history.push(`/bid-proposal-submit-result?result=success`);
    } catch (error: any) {
      history.push(`/bid-proposal-submit-result?result=fail`);
    }
  };

  const _downloadFile = async (fileData: any) => {
    if (data === null) return;
    await downloadFile(
      getBidChanceSharedFileAPIPath(data.id + ''),
      '' + fileData.id,
      fileData.name,
    );
    /*
    if (isMobile) {
      if (
        fileData.name.split('.').pop() !== 'jpg' &&
        fileData.name.split('.').pop() !== 'jpeg' &&
        fileData.name.split('.').pop() !== 'png' &&
        fileData.name.split('.').pop() !== 'pdf'
      ) {
        alert(
          // '스마트폰에서는 다운로드를 지원하지 않습니다. PC에서 이용해주세요.',
          `스마트폰에서는 ${fileData.name
            .split('.')
            .pop()} 파일을 다운로드 할 수 없습니다. PC에서 이용해주세요.`,
          // '스마트폰에서는 미리보기만 지원합니다.',
        );
      } else {
      }
    } else {
      // donwloadFile('' + record.id, record.name);
      await downloadFile(
        getBidChanceSharedFileAPIPath(data.id + ''),
        '' + fileData.id,
        fileData.name,
      );
    }
    */
  };

  const onFinish = (formData: any) => {
    dispatch(
      getBidChanceDetail2Async.request({
        d1: d1,
        d2: d2,
        bmt: bmt,
        input: formData.input.trim(),
      }),
    );
    setVisible2(false);
  };

  return (
    <Layout style={{ padding: '40px', background: '#fff' }}>
      {loading && <Spin />}
      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
        />
      )}
      {data && (
        <BidChanceDetailComponent
          bidChance={data}
          coords={coords}
          moveToCreateBidProposalPage={moveToCreateBidProposalPage}
          downloadFile={_downloadFile}
          changeBidStatus={changeBidStatus}
        />
      )}
      <BidProposalCreateModal
        visible={visible1}
        uploadProps={uploadProps}
        onFinish={submitBidProposal}
        onCancel={closeBidProposalCreateModal}
      />

      {
        <BidInvitationInputModal
          visible={visible2}
          isEmail={bmt === 'EMAIL'}
          onFinish={onFinish}
        />
      }
    </Layout>
  );
}
export default BidInvitationContainer;
